export default __webpack_public_path__ + "static/media/VampireNovels.f53d87b9.png";